export default function (date, rangeStarts, rangeEnds) {
  const currentDate = new Date(date).getTime()
  const starts = new Date(rangeStarts).getTime()
  const ends = new Date(rangeEnds).getTime()

  if (currentDate >= starts && currentDate <= ends)
    return true

  else
    return false
}
